import { SWITCH_THEME ,SET_PREVIOUS_ROUTE} from '../actions/theme'
const initialState = {
    value: 'W',
    previousRoute: [],
}
function themeReducer(state = initialState, action) {
    const htmlTag = document.querySelector("html");
    const appliedTheme = localStorage.getItem('theme')

    switch (action.type) {
        case SWITCH_THEME:
            localStorage.setItem("theme", action.theme)
            htmlTag.setAttribute("class", action.theme === "D" ? "dark" : "");
            return {...state, value: action.theme }
        case SET_PREVIOUS_ROUTE:
            return {
                ...state,
                previousRoute: [state?.previousRoute[state?.previousRoute?.length - 1] ,action.payload],
            };    
        default:
            //localStorage.setItem("theme", appliedTheme === "D" ? "dark" : undefined)
            htmlTag.setAttribute("class", appliedTheme === "D" ? "dark" : "");
            return { ...state,value: appliedTheme === "D" ? "D" : "W" }
    }
}

export default themeReducer;